import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isBuildUp, isFlexible, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidEstManuFactoryId = (values: EstimateValues, silk?: string) => {
  switch (silk) {
    case ESTIMATE_CONSTANT.製造工場.指定なし.value:
      return true
    case ESTIMATE_CONSTANT.製造工場.韓国.value:
      return (isRigid(values) && !isBuildUp(values)) || isFlexible(values)
    case ESTIMATE_CONSTANT.製造工場.台湾.value:
      return isRigid(values) && !isBuildUp(values)
    case ESTIMATE_CONSTANT.製造工場["日本(リジッド)"].value:
      return isRigid(values) && !isBuildUp(values)
    case ESTIMATE_CONSTANT.製造工場["日本(フレキシブル)"].value:
      return isFlexible(values)
    default:
      return false
  }
}

export default isValidEstManuFactoryId
